import { SelectorBase } from "../../Config/SelectorBase";
import ActivityCategory, { IActivityCategoryModel } from './ActivityCategory';
import ActivityTheme from '../ActivityTheme/ActivityTheme';
import { store } from 'src';
import { ActivitySelector } from '../Activity/Activity.Selector';
import { UserSelector } from '../User/User.Selector';
import { IActivityModel } from '../Activity/Activity';

/* Selector represents the data 
 * that needs to be displayed no update or delete should here
 * All of the updates and delete (data changes) should 
 * be done via action in the reducer
 */
export class ActivityCategorySelector extends SelectorBase {
    public static getCategories(): IActivityCategoryModel[] {
        const session = super.getDataSource();
        const activityCategory :IActivityCategoryModel[]= session.ActivityCategory.all().toModelArray();          
        return activityCategory.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));;
    }
    public static getCategoryById(id: string): IActivityCategoryModel {
        const session = super.getDataSource();
        const activityCategory = session.ActivityCategory.withId(id)
        return activityCategory;
    }

    public static getCategoriesByThemeId(themeId: number, showRelevant: boolean = false){                        
        let categories : IActivityCategoryModel[]
        if(showRelevant ){
            const userInterests = UserSelector.getUserInterests()
            if(userInterests !== undefined){
                if(userInterests.length>0){
                    categories = this.getCategories()
                    .filter(c => c.themeId.toString() === themeId.toString() && ActivitySelector.getActivitiesByCategoryId(c.categoryId).length >= 1 && userInterests.indexOf(c.categoryId.toString()) !== -1 );        
                    return categories;
                }
        }

                 
        }
        
        return categories = this.getCategories().filter(c => c.themeId.toString() === themeId.toString() && ActivitySelector.getActivitiesByCategoryId(c.categoryId).length >= 1);        
        
             

    }

}


// WEBPACK FOOTER //
// ./src/Entities/ActivityCategory/ActivityCategory.Selector.ts